import {ref} from "vue";

export function useForm(callback, options = {}) {
  const errors = ref({});
  const errorMessage = ref();
  const busy = ref(false);

  const hasError = (field) => {
    return Object.keys(errors.value).includes(field);
  }

  const getError = (field = undefined) => {
    if (hasError(field)) {
      const error = errors.value[field];

      return Array.isArray(error) && error.length > 0 ? error.join('. ') : error;
    }

    if (field === undefined) {
      return errorMessage.value;
    }

    return '';
  }

  const handleErrors = (error) => {
    if (error?.response?.data) {
      errors.value = error.response.data.errors || {};
      errorMessage.value = error.response.data.message || '';
    } else if (error.message) {
      errorMessage.value = error.message || '';
    } else {
      console.log(error);
    }
  }

  const submit = async () => {
    reset();
    busy.value = true;

    try {
      await callback();
    } catch (e) {
      handleErrors(e);
      if (options?.throwError) {
        throw e;
      }
    } finally {
      busy.value = false;
    }
  }

  const reset = () => {
    errors.value = {};
    errorMessage.value = '';
    busy.value = false;
  }

  return {submit, errors, errorMessage, getError, hasError, busy, reset, handleErrors}
}
